<template>
  <div id="check-in-errato">
    <br />
    <div>
      <h2>Dati Check-in Errati</h2>
      <p>Si è cercato di accedere al check-in online con un link non valido. Si prega di utilizzare il link contenuto all'interno dell'email ricevuta al momento della prenotazione.</p>
      <p>
        Per assistenza, si prega di rivolgersi alla struttura presso la quale si è effettuata la prenotazione oppure inviare un'email a:
        <a
          v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn"
        >{{ $store.state.EmailFacileCheckIn }}</a>.
      </p>

      <p>
        Ci scusiamo per il disagio.
        <br />
        <NomeSitoPiccolo />
      </p>
    </div>

    <br />

    <div>
      <h2>Incorrect Check-in data</h2>
      <p>You tried to access online check-in with an invalid link. Please use the link contained in the email received at the time of booking.</p>
      <p>
        For assistance, please contact the facility where you made the reservation or send an email to:
        <a
          v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn"
        >{{ $store.state.EmailFacileCheckIn }}</a>.
      </p>
      <p>
        We apologize for the inconvenience.
        <br />
        <NomeSitoPiccolo />
      </p>
    </div>

    <br />

    <div>
      <h2>Falsche Eincheckdaten</h2>
      <p>Sie haben versucht, über einen ungültigen Link auf den Online-Check-in zuzugreifen. Bitte verwenden Sie den Link, der in der E-Mail enthalten ist, die Sie zum Zeitpunkt der Buchung erhalten haben.</p>
      <p>
        Wenn Sie Hilfe benötigen, wenden Sie sich bitte an die Immobilie, bei der Sie die Reservierung vorgenommen haben, oder senden Sie eine E-Mail an:
        <a
          v-bind:href="'mailto:' + $store.state.EmailFacileCheckIn"
        >{{ $store.state.EmailFacileCheckIn }}</a>.
      </p>
      <p>
        Wir entschuldigen uns für die Unannehmlichkeiten.
        <br />
        <NomeSitoPiccolo />
      </p>
    </div>
  </div>
</template>

<script>
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo.vue";

export default {
  name: "LinkNonValido",
  data() {
    return {};
  },
  components: {
    NomeSitoPiccolo
  },
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  text-align: justify;
}
</style>
